module.exports = __webpack_public_path__ + "static/media/learning-packages.4e68d9aa.png";